// extracted by mini-css-extract-plugin
export var smallSpinner = "_xn-0";